import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

export function LargeAreaChart() {
  const chartRef = useRef(null);

  useEffect(() => {
    let chartInstance = null;

    // Initialize chart with a small delay
    const timer = setTimeout(() => {
      if (chartRef.current) {
        // Initialize the chart
        chartInstance = echarts.init(chartRef.current);

        // Sample data setup
      let base = +new Date(2025, 9, 3); // Oct 3, 2025
let oneDay = 24 * 3600 * 1000;
let date = [];
let data = [Math.random() * 3050];

const today = new Date();
today.setHours(0, 0, 0, 0); // Ensure only date part is considered

let current = base;

while (current <= today.getTime()) {
  const now = new Date(current);
  date.push(
    [now.getFullYear(), now.getMonth() + 1, now.getDate()].join("/")
  );

  const prev = data[data.length - 1];
  data.push(Math.round((Math.random() - 0.5) * 20 + prev));

  current += oneDay;
}


        // Chart configuration
        const option = {
          tooltip: {
            trigger: "axis",
            position: function (pt) {
              return [pt[0], "10%"];
            },
          },
          title: {
            left: "left",
            text: "Energy Consumption",
            textStyle: {
              fontSize: 14,
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            bottom: "15%",
            top: "15%",
            containLabel: true,
          },
          //   toolbox: {
          //     feature: {
          //       dataZoom: { yAxisIndex: 'none' },
          //       restore: {},
          //       saveAsImage: {}
          //     }
          //   },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: date,
          },
          yAxis: {
            type: "value",
            boundaryGap: [0, "100%"],
          },
          // dataZoom: [ //scrollbar
          //   {
          //     type: "inside",
          //     start: 0,
          //     end: 10,
          //   },
          //   {
          //     start: 0,
          //     end: 10,
          //     height: 20,
          //   },
          // ],
          series: [
            {
              name: "Energy",
              type: "line",
              symbol: "none",
              sampling: "lttb",
              itemStyle: {
                color: "rgb(255, 70, 131)",
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgb(255, 158, 68)" },
                  { offset: 1, color: "rgb(255, 70, 131)" },
                ]),
              },
              data: data,
            },
          ],
        };

        // Apply the configuration
        chartInstance.setOption(option);
      }
    }, 100);

    // Handle resize to fit the container
    const handleResize = () => {
      if (chartInstance) {
        chartInstance.resize();
      }
    };

    window.addEventListener("resize", handleResize);

    // Create a resize observer to detect container size changes
    const resizeObserver = new ResizeObserver(() => {
      if (chartInstance) {
        chartInstance.resize();
      }
    });

    if (chartRef.current) {
      resizeObserver.observe(chartRef.current);
    }

    // Cleanup function
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
      resizeObserver.disconnect();
      if (chartInstance) {
        chartInstance.dispose();
      }
    };
  }, []);

  // IMPORTANT: The key is to set height and width to 100% and absolute position
  // This prevents the chart from affecting the parent container's layout
  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    />
  );
}

export function WaterfallChart() {
  const chartRef = useRef(null);

  useEffect(() => {
    let chartInstance = null;

    // Initialize chart with a small delay
    const timer = setTimeout(() => {
      if (chartRef.current) {
        // Initialize the chart
        chartInstance = echarts.init(chartRef.current);

        // Chart configuration
        const option = {
          title: {
            text: "Energy Consumption By Asset Type",
            left: "left",
            textStyle: {
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
            formatter: function (params) {
              const tar = params[1];
              return tar.name + "<br/>" + tar.seriesName + " : " + tar.value;
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            bottom: "15%",
            top: "15%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            splitLine: { show: false },
            data: ["A", "B", "C", "D", "E", "F"],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "Placeholder",
              type: "bar",
              stack: "Total",
              itemStyle: {
                borderColor: "transparent",
                color: "transparent",
              },
              emphasis: {
                itemStyle: {
                  borderColor: "transparent",
                  color: "transparent",
                },
              },
              data: [0, 1700, 1400, 1200, 300, 0],
            },
            {
              name: "Consumption",
              type: "bar",
              stack: "Total",
              label: {
                show: true,
                position: "inside",
              },
              data: [2900, 1200, 300, 200, 900, 300],
            },
          ],
        };

        // Apply the configuration
        chartInstance.setOption(option);
      }
    }, 100);

    // Handle resize to fit the container
    const handleResize = () => {
      if (chartInstance) {
        chartInstance.resize();
      }
    };

    window.addEventListener("resize", handleResize);

    // Create a resize observer to detect container size changes
    const resizeObserver = new ResizeObserver(() => {
      if (chartInstance) {
        chartInstance.resize();
      }
    });

    if (chartRef.current) {
      resizeObserver.observe(chartRef.current);
    }

    // Cleanup function
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
      resizeObserver.disconnect();
      if (chartInstance) {
        chartInstance.dispose();
      }
    };
  }, []);

  // Return the chart container div
  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    />
  );
}

export function Heatmap() {
  const chartRef = useRef(null);

  useEffect(() => {
    let chartInstance = null;

    const hours = [
      "12a",
      "1a",
      "2a",
      "3a",
      "4a",
      "5a",
      "6a",
      "7a",
      "8a",
      "9a",
      "10a",
      "11a",
      "12p",
      "1p",
      "2p",
      "3p",
      "4p",
      "5p",
      "6p",
      "7p",
      "8p",
      "9p",
      "10p",
      "11p",
    ];
    const days = [
      "Saturday",
      "Friday",
      "Thursday",
      "Wednesday",
      "Tuesday",
      "Monday",
      "Sunday",
    ];

    const rawData = [
      [0, 0, 5],
      [0, 1, 1],
      [0, 2, 0],
      [0, 3, 0],
      [0, 4, 0],
      [0, 5, 0],
      [0, 6, 0],
      [0, 7, 0],
      [0, 8, 0],
      [0, 9, 0],
      [0, 10, 0],
      [0, 11, 2],
      [0, 12, 4],
      [0, 13, 1],
      [0, 14, 1],
      [0, 15, 3],
      [0, 16, 4],
      [0, 17, 6],
      [0, 18, 4],
      [0, 19, 4],
      [0, 20, 3],
      [0, 21, 3],
      [0, 22, 2],
      [0, 23, 5],
      [1, 0, 7],
      [1, 1, 0],
      [1, 2, 0],
      [1, 3, 0],
      [1, 4, 0],
      [1, 5, 0],
      [1, 6, 0],
      [1, 7, 0],
      [1, 8, 0],
      [1, 9, 0],
      [1, 10, 5],
      [1, 11, 2],
      [1, 12, 2],
      [1, 13, 6],
      [1, 14, 9],
      [1, 15, 11],
      [1, 16, 6],
      [1, 17, 7],
      [1, 18, 8],
      [1, 19, 12],
      [1, 20, 5],
      [1, 21, 5],
      [1, 22, 7],
      [1, 23, 2],
      [2, 0, 1],
      [2, 1, 1],
      [2, 2, 0],
      [2, 3, 0],
      [2, 4, 0],
      [2, 5, 0],
      [2, 6, 0],
      [2, 7, 0],
      [2, 8, 0],
      [2, 9, 0],
      [2, 10, 3],
      [2, 11, 2],
      [2, 12, 1],
      [2, 13, 9],
      [2, 14, 8],
      [2, 15, 10],
      [2, 16, 6],
      [2, 17, 5],
      [2, 18, 5],
      [2, 19, 5],
      [2, 20, 7],
      [2, 21, 4],
      [2, 22, 2],
      [2, 23, 4],
      [3, 0, 7],
      [3, 1, 3],
      [3, 2, 0],
      [3, 3, 0],
      [3, 4, 0],
      [3, 5, 0],
      [3, 6, 0],
      [3, 7, 0],
      [3, 8, 1],
      [3, 9, 0],
      [3, 10, 5],
      [3, 11, 4],
      [3, 12, 7],
      [3, 13, 14],
      [3, 14, 13],
      [3, 15, 12],
      [3, 16, 9],
      [3, 17, 5],
      [3, 18, 5],
      [3, 19, 10],
      [3, 20, 6],
      [3, 21, 4],
      [3, 22, 4],
      [3, 23, 1],
      [4, 0, 1],
      [4, 1, 3],
      [4, 2, 0],
      [4, 3, 0],
      [4, 4, 0],
      [4, 5, 1],
      [4, 6, 0],
      [4, 7, 0],
      [4, 8, 0],
      [4, 9, 2],
      [4, 10, 4],
      [4, 11, 4],
      [4, 12, 2],
      [4, 13, 4],
      [4, 14, 4],
      [4, 15, 14],
      [4, 16, 12],
      [4, 17, 1],
      [4, 18, 8],
      [4, 19, 5],
      [4, 20, 3],
      [4, 21, 7],
      [4, 22, 3],
      [4, 23, 0],
      [5, 0, 2],
      [5, 1, 1],
      [5, 2, 0],
      [5, 3, 3],
      [5, 4, 0],
      [5, 5, 0],
      [5, 6, 0],
      [5, 7, 0],
      [5, 8, 2],
      [5, 9, 0],
      [5, 10, 4],
      [5, 11, 1],
      [5, 12, 5],
      [5, 13, 10],
      [5, 14, 5],
      [5, 15, 7],
      [5, 16, 11],
      [5, 17, 6],
      [5, 18, 0],
      [5, 19, 5],
      [5, 20, 3],
      [5, 21, 4],
      [5, 22, 2],
      [5, 23, 0],
      [6, 0, 1],
      [6, 1, 0],
      [6, 2, 0],
      [6, 3, 0],
      [6, 4, 0],
      [6, 5, 0],
      [6, 6, 0],
      [6, 7, 0],
      [6, 8, 0],
      [6, 9, 0],
      [6, 10, 1],
      [6, 11, 0],
      [6, 12, 2],
      [6, 13, 1],
      [6, 14, 3],
      [6, 15, 4],
      [6, 16, 0],
      [6, 17, 0],
      [6, 18, 0],
      [6, 19, 0],
      [6, 20, 1],
      [6, 21, 2],
      [6, 22, 2],
      [6, 23, 6],
    ];

    const data = rawData.map((item) => [item[1], item[0], item[2] || "-"]);

    const option = {
      tooltip: { position: "top" },
      grid: {
        left: "5%", // Adjust this value as needed
        right: "10%",
        top: "20%",
        bottom: "15%",
        containLabel: true,
      },

      xAxis: {
        type: "category",
        data: hours,
        splitArea: { show: true },
      },
      title: {
        left: "left",
        text: "Energy Consumption By Area",
        textStyle: {
          fontSize: 14,
        },
      },
      yAxis: {
        type: "category",
        data: days,
        splitArea: { show: true },
        axisLabel: {
          interval: 0, // 👈 Show all labels
        },
      },
      visualMap: {
        min: 0,
        max: 10,
        calculable: true,
        orient: "horizontal",
        left: "center",
        bottom: "1%",
        show: false, // 👈 This hides the scrollbar/legend
      },
      series: [
        {
          name: "Punch Card",
          type: "heatmap",
          data: data,
          label: {
            left: 15,
            show: false, //if true shows numbers on the individual grids of cards
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };

    const timer = setTimeout(() => {
      if (chartRef.current) {
        chartInstance = echarts.init(chartRef.current);
        chartInstance.setOption(option);
      }
    }, 100);
    // function updateChart() {
    //   if (chartRef.current) {
    //     chartInstance = echarts.init(chartRef.current);
    //     chartInstance.setOption(option);
    //   }
    // }

    // // Initial load
    // updateChart();

    // Then repeat every hour
    // const timer = setInterval(updateChart, 3600000);

    // const timer = setInterval(() => {
    //   if (chartRef.current) {
    //     chartInstance = echarts.init(chartRef.current);
    //     chartInstance.setOption(option);
    //   }
    // }, 3600000); // 1 hour = 3600000 ms
    const handleResize = () => {
      if (chartInstance) {
        chartInstance.resize();
      }
    };

    window.addEventListener("resize", handleResize);

    const resizeObserver = new ResizeObserver(() => {
      if (chartInstance) {
        chartInstance.resize();
      }
    });

    if (chartRef.current) {
      resizeObserver.observe(chartRef.current);
    }

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
      resizeObserver.disconnect();
      if (chartInstance) {
        chartInstance.dispose();
      }
    };
  }, []);

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 25,
      }}
    />
  );
}

export function ResponsiveBarChart() {
  const chartRef = useRef(null);

  useEffect(() => {
    let chartInstance = null;

    // Initialize chart with a small delay
    const timer = setTimeout(() => {
      if (chartRef.current) {
        // Initialize the chart
        chartInstance = echarts.init(chartRef.current);

        // Chart configuration
        const option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            bottom: "15%",
            top: "15%",
            containLabel: true,
          },
          title: {
            left: "left",
            text: "Asset Health",
            textStyle: {
              fontSize: 14,
            },
          },
          xAxis: {
            type: "category",
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },
          yAxis: {
            type: "value",
          },
          // dataZoom: [
          //   {
          //     type: "inside",
          //     start: 0,
          //     end: 100,
          //   },
          //   {
          //     start: 0,
          //     end: 100,
          //     height: 20,
          //   },
          // ],
          series: [
            {
              data: [
                120,
                {
                  value: 200,
                  itemStyle: {
                    color: "#a90000",
                  },
                },
                150,
                80,
                70,
                110,
                130,
              ],
              type: "bar",
              // Add a gradient to the bars
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" },
                ]),
              },
              emphasis: {
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#2378f7" },
                    { offset: 0.7, color: "#2378f7" },
                    { offset: 1, color: "#83bff6" },
                  ]),
                },
              },
            },
          ],
        };

        // Apply the configuration
        chartInstance.setOption(option);
      }
    }, 100);

    // Handle resize to fit the container
    const handleResize = () => {
      if (chartInstance) {
        chartInstance.resize();
      }
    };

    window.addEventListener("resize", handleResize);

    // Create a resize observer to detect container size changes
    const resizeObserver = new ResizeObserver(() => {
      if (chartInstance) {
        chartInstance.resize();
      }
    });

    if (chartRef.current) {
      resizeObserver.observe(chartRef.current);
    }

    // Cleanup function
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
      resizeObserver.disconnect();
      if (chartInstance) {
        chartInstance.dispose();
      }
    };
  }, []);

  // Set height and width to 100% and absolute position
  // This prevents the chart from affecting the parent container's layout
  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    />
  );
}

export default { LargeAreaChart, WaterfallChart, Heatmap, ResponsiveBarChart };
